import Request from "./Request";

class GetRequest extends Request {
    constructor(url: string) {
        super("GET", url);
    }
}

export default GetRequest;